import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import axios from "axios";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import EditorViewer from "@/components/pageEditor/EditorViewer.vue";
let ChapterDocumentViewer = class ChapterDocumentViewer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "pageHtmlContent", '');
  }
  mounted() {
    this.getPageEditorContentAndBuildEditorConfig();
  }
  getPageEditorContentAndBuildEditorConfig() {
    axios.get(`/api/v2/chapter/${this.chapterId}/html-content`).then(({
      data
    }) => {
      this.pageHtmlContent = data?.htmlContent || '';
    }).catch(() => WElMessage.showErrorMessage(this.$t('errors.default')));
  }
};
__decorate([Prop({
  required: true
})], ChapterDocumentViewer.prototype, "chapterId", void 0);
ChapterDocumentViewer = __decorate([Component({
  components: {
    EditorViewer
  }
})], ChapterDocumentViewer);
export default ChapterDocumentViewer;